var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.shade)?_c('div',{staticClass:"cover-layer invisible"}):_vm._e(),_c('div',{staticClass:"sub-message flex-column flex-center an an-fadein",class:{'an-fadeout': _vm.end},on:{"click":_vm.hide}},[(_vm.iconClass)?_c('i',{staticClass:"sf",class:[_vm.iconClass]}):_vm._e(),_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }